import React from 'react';
/* eslint-disable-next-line no-unused-vars */
import PropTypes from 'prop-types';

import './CommunityCommentsDisplay.scss';
import { singleCommentPropTypes } from '../../../../pages/defaultProps';
import CommentList from '../../CommentBox/CommentList/CommentList';
import CommonCardShell from '../../../Layout/CommonCardShell/CommonCardShell';
import SVGIconWrapper from '../../../Icons/SVGIconWrapper/SVGIconWrapper';
import Icons from '../../../Messages/Icons/Icons';
import { getMMDDYYTimestamp } from '../../../Utilities/TimeFunctions';
import CardHeader from '../../../Groups/CardHeader/CardHeader';

const CommunityCommentsDisplay = (props) => {
    const { content } = props;
    const { hash, location } = props.content;
    const ancestorHash =
        !content.ancestorHash || content.ancestorHash === content.hash
            ? ''
            : `/${content.ancestorHash}`;
    const contentUrl = content?.group?.groupUrl
        ? `${content?.group.groupUrl}${content?.contentUrl}`
        : content.contentUrl;

    const parentContentTitle = () => {
        switch (content.type) {
            case 'editorial-content':
                return content.article.contentTitle;
            case 'community-link':
                return content.description;
            case 'community-photo':
                return content.description;
            case 'community-discussion':
                return content.title;
            case 'community-podcast':
                return content.podcast.contentTitle;
            default:
                return '';
        }
    };

    const groupHeader = content?.group?.groupUrl ? (
        <div className="group-post-header">
            <CardHeader>Group Post</CardHeader>
        </div>
    ) : null;

    const backLinkText = () => {
        if (content.ancestorHash) {
            return 'Reply';
        }
        return 'Content';
    };

    const renderBackToContentLink = () => {
        return (
            <a
                className="back-to-parent-link"
                href={`${contentUrl}${ancestorHash}`}
            >
                <SVGIconWrapper SVGWrapperCssClass="back-caret">
                    <Icons name="back-caret" />
                </SVGIconWrapper>
                {`Return to ${backLinkText()}`}
            </a>
        );
    };

    const renderBackToGroupPage = () =>
        content?.group?.groupUrl && (
            <a href={content?.group?.groupUrl} className="back-to-groups-link">
                Back to group page
            </a>
        );

    return (
        <CommonCardShell className="component-Community-SingleContent-CommunityCommentsDisplay">
            {groupHeader}
            {renderBackToContentLink()}
            <div className="parent-content-description">
                <p>{`Commented on ${getMMDDYYTimestamp(
                    props.content.streamDate
                )} -`}</p>
                <a href={contentUrl} className="parent-content-link">
                    {parentContentTitle()}
                </a>
            </div>
            <CommentList hash={hash} location={location} />
            {renderBackToContentLink()}
            {renderBackToGroupPage()}
        </CommonCardShell>
    );
};

CommunityCommentsDisplay.propTypes = {
    /**
     * Content props
     */
    content: PropTypes.shape({
        type: PropTypes.string,
        hash: PropTypes.string,
        location: PropTypes.string,
        streamDate: PropTypes.string,
        lastId: PropTypes.number,
        ancestorHash: PropTypes.string,
        commentCount: PropTypes.number,
        contentUrl: PropTypes.string,
        slug: PropTypes.string,
        comments: PropTypes.arrayOf(PropTypes.shape(singleCommentPropTypes)),
        article: PropTypes.shape({
            contentTitle: PropTypes.string,
        }),
        link: PropTypes.shape({
            previewTitle: PropTypes.string,
        }),
        podcast: PropTypes.shape({
            contentTitle: PropTypes.string,
        }),
        title: PropTypes.string,
        description: PropTypes.string,
        group: PropTypes.shape({
            groupUrl: PropTypes.string,
        }),
    }).isRequired,
};

CommunityCommentsDisplay.defaultProps = {};

CommunityCommentsDisplay.displayName = 'CommunityCommentsDisplay';

export default React.memo(CommunityCommentsDisplay);
